import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { IonPage, IonHeader, IonToolbar, IonTitle, IonIcon, IonBadge, useIonRouter } from '@ionic/vue';
import { ref, reactive , onMounted } from 'vue';
import { cart , arrowBackOutline } from 'ionicons/icons';
import { useStore } from 'vuex';
import { key } from '../store/index';
import CheckoutUser from '@/components/CheckoutUser.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckoutStart',
  setup(__props) {

const store = useStore(key);
const ionicRouter = useIonRouter();

const cartitemnum = ref(store.state.cart.length);

const cartdata = reactive(store.state.cart);

onMounted(()=>{
    console.log('cart', store.state.cart)
    store.dispatch('getTokenData');
})

function goBack(){
    ionicRouter.back(-1)
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonHeader), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonToolbar), { color: "danger" }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonIcon), {
                icon: _unref(arrowBackOutline),
                slot: "start",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (goBack()))
              }, null, 8, ["icon"]),
              _createVNode(_unref(IonTitle), null, {
                default: _withCtx(() => [
                  _createTextVNode("Checkout Uniboi")
                ]),
                _: 1
              }),
              _createVNode(_unref(IonIcon), {
                collapse: true,
                slot: "end",
                icon: _unref(cart),
                onClick: _cache[1] || (_cache[1] = () => _ctx.router.push('/tabs/carrinho'))
              }, null, 8, ["icon"]),
              _createVNode(_unref(IonBadge), {
                color: "dark",
                slot: "end"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(cartitemnum.value), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(CheckoutUser)
    ]),
    _: 1
  }))
}
}

})